import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Heading } from 'quantic'
import Particles from './Particles'

const Container = styled.main`
  margin: 0 auto;
  padding: 0;
  width: 95%;
  max-width: ${({ maxWidth }) => maxWidth};

  @media screen and (max-width: 700px) {
    margin-bottom: 70px;
  }
`

const ReturnPath = styled.div``

const Header = styled.header`
  width: 100%;
  padding: 10px;
`

const Content = styled.div`
  width: 100%;
  padding: 20px;

  background: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => `solid ${theme.colors.whiteDark} 1px`};
  box-shadow: none;
  border-radius: 3px;

  @media screen and (max-width: 700px) {
    border-radius: 0;
  }
`

function Layout({ children, title, description, returnPath, maxWidth }) {
  const { push } = useHistory()

  return (
    <Container maxWidth={maxWidth}>
      <Particles />
      <Header>
        {returnPath && <ReturnPath onClick={() => push(returnPath)}>{'<'} Voltar</ReturnPath>}
        {title && <Heading h1>{title}</Heading>}
        {description && <Heading subtitle>{description}</Heading>}
      </Header>
      <Content>{children}</Content>
    </Container>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  returnPath: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Layout.defaultProps = {
  title: undefined,
  description: undefined,
  returnPath: undefined,
  maxWidth: '1180px',
}

export default Layout
